import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(processLinkedProfilesChannel);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createReducer, createAction, createSelector, loadSessionSuccess, invalidate, invalidateOnCustomerChange, startLoading, stopLoading, upToDateStatus } from '@techstyle/redux-core';
import { logInSuccess, signUpSuccess } from './accountsModule';
import { LinkedProfiles } from './schema';
import { apiGenderMap, Gender } from './constants';
import { actionChannel, putResolve, take } from 'redux-saga/effects';
var initialState = {
  allProfiles: [],
  membershipProfileId: null,
  defaultGender: Gender.FEMALE,
  networkStatus: upToDateStatus()
};
export var linkedProfilesActionChannel = 'loadProfiles';
export var invalidateProfiles = createAction('accounts/invalidateProfiles');
export var loadProfilesType = 'accounts/loadProfiles';
export var loadProfilesRequest = createAction('accounts/loadProfilesRequest');
export var loadProfilesSuccess = createAction('accounts/loadProfilesSuccess', function (action) {
  var _action$payload = action.payload,
      allProfiles = _action$payload.allProfiles,
      membershipProfileId = _action$payload.membershipProfileId;
  action.payload = {
    allProfiles: allProfiles,
    membershipProfileId: membershipProfileId
  };
});
export var loadProfilesFailure = createAction('accounts/loadProfilesFailure');
export function loadProfiles() {
  return {
    type: loadProfilesType,
    channel: linkedProfilesActionChannel,
    payload: function payload(dispatch, getState) {
      var networkStatus = getState().linkedProfiles.networkStatus;

      if (!networkStatus.isUpToDate && !networkStatus.isLoading) {
        return dispatch({
          bentoApi: {
            endpoint: 'accounts/me/profiles',
            requestKey: 'loadProfiles',
            schema: LinkedProfiles,
            actions: [loadProfilesRequest, loadProfilesSuccess, loadProfilesFailure]
          }
        });
      }
    }
  };
}
export var updateActiveLinkedProfileByGenderType = 'accounts/updateActiveLinkedProfileByGender';
export var updateActiveLinkedProfileByGenderRequest = createAction('accounts/updateActiveLinkedProfileByGenderRequest');
export var updateActiveLinkedProfileByGenderSuccess = createAction('accounts/updateActiveLinkedProfileByGenderSuccess');
export var updateActiveLinkedProfileByGenderFailure = createAction('accounts/updateActiveLinkedProfileByGenderFailure');
export var updateActiveLinkedProfileType = 'accounts/updateActiveLinkedProfile';
export var updateActiveLinkedProfileRequest = createAction('accounts/updateActiveLinkedProfileRequest');
export var updateActiveLinkedProfileSuccess = createAction('accounts/updateActiveLinkedProfileSuccess');
export var updateActiveLinkedProfileFailure = createAction('accounts/updateActiveLinkedProfileFailure');
export function updateActiveLinkedProfileByGender(gender) {
  var genderParam = apiGenderMap[gender];

  if (!genderParam) {
    throw new Error('updateActiveLinkedProfileByGender must be called with `M` or `F` gender key');
  }

  return {
    type: updateActiveLinkedProfileByGenderType,
    channel: linkedProfilesActionChannel,
    payload: {
      bentoApi: {
        method: 'PATCH',
        endpoint: "accounts/me/profiles/".concat(genderParam, "/active"),
        schema: LinkedProfiles,
        actions: [updateActiveLinkedProfileByGenderRequest, updateActiveLinkedProfileByGenderSuccess, updateActiveLinkedProfileByGenderFailure]
      }
    }
  };
}
export function updateActiveLinkedProfile(linkedProfileId) {
  if (!linkedProfileId) {
    throw new Error('updateActiveLinkedProfile must be called with a linked profile ID');
  }

  return {
    type: updateActiveLinkedProfile,
    channel: linkedProfilesActionChannel,
    payload: {
      bentoApi: {
        method: 'PATCH',
        endpoint: "accounts/me/profiles/".concat(linkedProfileId, "/active"),
        schema: LinkedProfiles,
        actions: [updateActiveLinkedProfileRequest, updateActiveLinkedProfileSuccess, updateActiveLinkedProfileFailure]
      }
    }
  };
}

var updateActiveLinkedProfiles = function updateActiveLinkedProfiles(state, action) {
  return _objectSpread(_objectSpread({}, action.payload), {}, {
    defaultGender: state.defaultGender,
    networkStatus: upToDateStatus()
  });
};

export function createLinkedProfilesReducer(defaults) {
  var _createReducer;

  return createReducer(_objectSpread(_objectSpread({}, initialState), defaults), (_createReducer = {}, _defineProperty(_createReducer, invalidateProfiles, invalidate), _defineProperty(_createReducer, logInSuccess, invalidate), _defineProperty(_createReducer, signUpSuccess, invalidate), _defineProperty(_createReducer, loadSessionSuccess, invalidateOnCustomerChange), _defineProperty(_createReducer, loadProfilesRequest, startLoading), _defineProperty(_createReducer, loadProfilesFailure, stopLoading), _defineProperty(_createReducer, loadProfilesSuccess, updateActiveLinkedProfiles), _defineProperty(_createReducer, updateActiveLinkedProfileByGenderRequest, startLoading), _defineProperty(_createReducer, updateActiveLinkedProfileByGenderFailure, stopLoading), _defineProperty(_createReducer, updateActiveLinkedProfileByGenderSuccess, updateActiveLinkedProfiles), _defineProperty(_createReducer, updateActiveLinkedProfileRequest, startLoading), _defineProperty(_createReducer, updateActiveLinkedProfileFailure, stopLoading), _defineProperty(_createReducer, updateActiveLinkedProfileSuccess, updateActiveLinkedProfiles), _createReducer));
}
export var getLinkedProfilesHelpers = createSelector([function (state) {
  return state.linkedProfiles;
}], function (linkedProfiles) {
  var currentProfile = linkedProfiles.allProfiles.find(function (profile) {
    return profile.isCurrent;
  }) || null;
  var currentGender = currentProfile ? currentProfile.gender : linkedProfiles.defaultGender;
  var hasFemaleProfile = linkedProfiles.allProfiles.some(function (profile) {
    return profile.gender === Gender.FEMALE;
  });
  var hasMaleProfile = linkedProfiles.allProfiles.some(function (profile) {
    return profile.gender === Gender.MALE;
  });
  return {
    currentGender: currentGender,
    currentProfile: currentProfile,
    hasFemaleProfile: hasFemaleProfile,
    hasMaleProfile: hasMaleProfile,
    isFemale: currentGender === Gender.FEMALE,
    isMale: currentGender === Gender.MALE
  };
});
export var getLinkedProfiles = createSelector([function (state) {
  return state.linkedProfiles;
}, getLinkedProfilesHelpers], function (linkedProfiles, linkedProfilesHelpers) {
  return _objectSpread(_objectSpread({}, linkedProfiles), linkedProfilesHelpers);
});
export function processLinkedProfilesChannel() {
  var channel, action;
  return _regeneratorRuntime.wrap(function processLinkedProfilesChannel$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return actionChannel(function (action) {
            return action.channel === linkedProfilesActionChannel;
          });

        case 2:
          channel = _context.sent;

        case 3:
          if (!true) {
            _context.next = 16;
            break;
          }

          _context.next = 6;
          return take(channel);

        case 6:
          action = _context.sent;
          _context.prev = 7;
          _context.next = 10;
          return putResolve(action.payload);

        case 10:
          _context.next = 14;
          break;

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](7);

        case 14:
          _context.next = 3;
          break;

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[7, 12]]);
}
export default function createLinkedProfilesModule(defaults) {
  return {
    id: 'linkedProfiles',
    reducerMap: {
      linkedProfiles: createLinkedProfilesReducer(defaults)
    },
    sagas: [processLinkedProfilesChannel]
  };
}